import React, { useRef, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale } from 'chart.js';

// Register the necessary components
ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale);

// Forward ref to allow access from parent component
const PieChartComponent = React.forwardRef((props, ref) => {

  const chartRef = useRef(null);

  // Forward the chartRef to the parent component via ref
  useEffect(() => {
    if (ref) {
      ref.current = chartRef.current;
    }
  }, [ref]);

  const data = {
    labels: props.labels,
    datasets: [
      {
        label: props.label,
        data: props.data,
        backgroundColor: props.backgroundColors,
      },
    ],
  };

  const options = {
    responsive: true,
    width: 468,
    height: 234,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
      },
      legend: {
        display: false,
      },
    },
    hover: {
      onHover: function (e) {
        let point = this.getElementAtEvent(e);
        e.target.style.cursor = point.length ? 'pointer' : 'default';
      },
    },
  };

  const chartClick = (evt) => {
    if (chartRef.current) {
      const chart = chartRef.current;
      const activePoints = chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true });
      if (activePoints.length > 0) {
        const idx = activePoints[0].index;
        const chartData = chart.data;
        const label = chartData.labels[idx];
        const value = chartData.datasets[0].data[idx];
        props.legendCallBack(evt, { text: label , value : value });
      }
    }
  };

  return (
  <div>
    <div style={{ height: '234px'}}>
      <Pie data={data} options={options} onClick={chartClick} ref={chartRef} /> 
    </div>
    <div className="legend">
    {props.labels.map((item, i) => (
      <div
        className="legend-item"
        key={item + i}
        onClick={(evt) => props.legendCallBack(evt, { text: item })}
      >
        <div className="color" style={{ backgroundColor: props.backgroundColors[i] }} />
        <span>{item}</span>
      </div>
    ))}
    </div>
  </div>
  );
});

// Prop validation
PieChartComponent.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  legendCallBack: PropTypes.func.isRequired,
  backgroundColors: PropTypes.array.isRequired
};

export default PieChartComponent;
